"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const E = require("fp-ts/lib/Either");
const _1 = require(".");
const pipeable_1 = require("fp-ts/lib/pipeable");
const businessIdRegEx = /^\d{7}\-\d{1}$/;
function businessId(path) {
    return (value) => pipeable_1.pipe(value.match(businessIdRegEx), E.fromNullable([
        new _1.ValidationError(path, `${value} is not correct business id`, new BusinessIdInfo(value))
    ]), E.map(_ => value));
}
exports.businessId = businessId;
class BusinessIdInfo {
    constructor(actual) {
        this.actual = actual;
        this.type = 'businessId';
    }
}
